export default __webpack_public_path__ + "static/media/ico-error-outline.3349cc4f.svg";